"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Immediately = /** @class */ (function () {
    function Immediately() {
        this.hasRendered = false;
    }
    Immediately.prototype.init = function (actionCallback) {
        var _this = this;
        if (this.hasRendered)
            return;
        setTimeout(function () {
            actionCallback();
            _this.hasRendered = true;
        }, 0);
    };
    Immediately.prototype.toString = function () {
        return 'triggered immediately';
    };
    return Immediately;
}());
exports.default = Immediately;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW1tZWRpYXRlbHkuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic3JjL2xpYi9zZXJ2aWNlcy90cmlnZ2Vycy9JbW1lZGlhdGVseS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUVBO0lBQUE7UUFDSSxnQkFBVyxHQUFHLEtBQUssQ0FBQTtJQWF2QixDQUFDO0lBWEcsMEJBQUksR0FBSixVQUFNLGNBQTZCO1FBQW5DLGlCQU1DO1FBTEcsSUFBSSxJQUFJLENBQUMsV0FBVztZQUFFLE9BQU07UUFDNUIsVUFBVSxDQUFDO1lBQ1AsY0FBYyxFQUFFLENBQUE7WUFDaEIsS0FBSSxDQUFDLFdBQVcsR0FBRyxJQUFJLENBQUE7UUFDM0IsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFBO0lBQ1QsQ0FBQztJQUVELDhCQUFRLEdBQVI7UUFDSSxPQUFPLHVCQUF1QixDQUFBO0lBQ2xDLENBQUM7SUFDTCxrQkFBQztBQUFELENBQUMsQUFkRCxJQWNDIn0=